import { html } from "../../base/_utils";

export function newsStoryCard(story) {
    return html`
        <div class="news-story-card card position-relative d-flex flex-column p-4 bg-primary bg-primary-texture fade-in z-1">
            <div class="card-body">
                <h3 class="h4 text-white mb-0">${story.title}</h3>
                <div class="color-bar mx-auto my-2"></div>
                <small class="font-tertiary-black text-white">${story.date}</small>
            </div>
            <div class="card-footer mt-3">
                <a class="btn btn-gray btn-sm" href="${story.link}" target="_blank">Read the Story</a>
            </div>
        </div>
    `;
}
